import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { Colors } from '../../shared/theme/styles.enum';

export const drawerWidth = 340;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerParent: {
      position: 'relative',
      borderRight: '1px solid #e8eaed',
      '@media (max-width:768px)': {
        display: 'none',
      },
    },
    drawer: {
      marginTop: -46,
      width: drawerWidth,
      flexShrink: 0,
      marginLeft: 'auto',
      '& .MuiBackdrop-root': {
        display: 'none',
      },
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        position: 'absolute',
        transition: 'none !important',
      },
    },
    drawerPaper: {
      width: drawerWidth,
      zIndex: 0,
    },
    drawerPaperMobile: {
      width: '80vw',
      maxWidth: 340,
      paddingTop: 16,
      boxShadow: '4px 0 24px rgba(0,0,0,0.12) !important',
    },
    drawerContainer: {
      overflow: 'auto',
    },
    closeMenuButton: {
      marginRight: 'auto',
      marginLeft: 0,
      color: Colors.White,
    },
    toolbar: {
      backgroundColor: Colors.Black,
    },
    menuActive: {
      backgroundColor: Colors.Black,
      borderLeft: '4.5px solid #5da595 !important',
    },
    menuButton: {
      marginRight: theme.spacing(3),
      display: 'none',
    },
    divider: {
      border: 'none',
      borderTop: '1px solid #e8eaed',
      marginBottom: 0,
    },
  })
);
